import { TopBarTypes } from '../TopBar/topBarTypes';
import { NavBarTypes } from '../NavBar/navBarTypes';
export namespace HeaderTypes {
  export type TLocationDetails = {
    location_city: string;
    location_state: string;
    location_name: string;
    facility_sms_id: string;
  };
  export type THeaderComponentType = {
    topbardata: TopBarTypes.ITopBarData | any;
    navbardata: NavBarTypes.INavBarConfig;
    locationDetails?: TLocationDetails[];
    onSetHeaderHeight: React.Dispatch<
      React.SetStateAction<{
        height: number;
        screenWidth: number;
      }>
    >;
    globalContext?: any;
    logOutHandler?: () => void;
  };
}
